import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HasStatusType } from '@app/shared/popup/has-status-type';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ok-cancel-modal-dialog',
    templateUrl: './ok-cancel.modal-dialog.html',
    standalone: false
})
export class OkCancelModalDialogComponent extends HasStatusType {
  private translate = inject(TranslateService);

  // Injected
  public title: string;
  public message: string;
  public okText: string;
  public cancelText: string;

  constructor() {
    const data = inject(MAT_DIALOG_DATA);
    super(data.type);

    this.title = data.dialogTitle;
    this.message = data.dialogMessage;

    this.okText = data.okText || this.translate.instant('BUTTON.OK');
    this.cancelText = data.cancelText || this.translate.instant('BUTTON.CANCEL');
  }
}
